import styled from "styled-components";

export const Select = styled.select`
  border: none;
  outline: none;
  font-family: 'Heebo', sans-serif;
  font-size: 0.85rem;
  color: #64748b;
  background: transparent;
  cursor: pointer;
  padding: 0 0.25rem;
  direction: rtl;
`;

export const Option = styled.option`
  font-family: 'Heebo', sans-serif;
`;
